/**
 * Returns a non-empty string id or `null`. Numbers are stringified because
 * TanStack Router's default search parser turns a purely numeric
 * `?rebateProgramIDs=9001` into the number 9001 on native navigation.
 */
const normalizeId = (value: unknown): string | null => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }
  return null;
};

/** Accepts a single id (string or number), a comma-separated string, or an
 * array (TanStack Router emits one of these depending on repetition and on
 * whether the id is purely numeric — see `normalizeId`). Every entry is
 * validated before trimming, so a malformed array member (an object, a
 * boolean, `NaN`) is dropped rather than throwing. */
export const decodeIdList = (raw: unknown): string[] => {
  if (raw == null) return [];
  const items = Array.isArray(raw)
    ? raw
    : typeof raw === "string"
      ? raw.split(",")
      : [raw];
  return items.map(normalizeId).filter((id): id is string => id !== null);
};
